// extracted by mini-css-extract-plugin
module.exports = {"chart":"src-components-Welcome-TransactionsChart-PieChart-PieChart-module__chart--3Lwv7"};